import { render } from "./Header.vue?vue&type=template&id=20059b09"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script